module.exports = __webpack_public_path__ + "img/cards.50a5e273.jpg";